import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField } from "@mui/material";
import MaterialTable, { MTableAction } from "material-table";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useEffect } from "react";
import { AddVisitorManagementRegionAction, DeleteVisitorManagementRegionAction, GetVisitorManagementRegionAction, UpdateVisitorManagementRegionAction } from "../../../../../store/Employee/Visitors/Action";

const VisitorsRegionGrid = () => {
  const dispatch = useDispatch();
  const { visitorRegionsData, visitorRegionsLoading } = useSelector(
      (state) => state?.EmployeeReducer?.VisitorsReducer
    );
  useEffect(() => {
    dispatch(GetVisitorManagementRegionAction());
  }, [dispatch]);

  return (
    <Box>
      <MaterialTable
        isLoading={visitorRegionsLoading}
        columns={[
          {
            title: "Entry Point",
            cellStyle: { padding: "5px 10px 0px 28px" },
            field: "region",
            validate: (rowData) => {
              if (rowData?.tableData && rowData?.tableData?.editing === "delete") {
                  return ""; 
              }
              if (!rowData?.region?.trim()) {
                return "Entry Point cannot be empty";
              }
              return "";
            },
            editComponent: (props) => {
              return (
                <Box sx={{ width: "70%" }}>
                  <TextField
                    required={true}
                    variant="standard"
                    fullWidth
                    value={props?.value}
                    onChange={(e) => props.onChange(e.target.value)}
                  />
                </Box>
              );
            },
          },
        ]}
        data={visitorRegionsData || []}
        icons={{
          Add: () =>( 
            <Button
                variant="contained" 
                className="mpl-primary-btn"
                style={{ minWidth: 0,width: "82px",height:"35px", padding: "2px 12px", textTransform: "none" }}
                startIcon={<AddIcon />}
              >
                Add
            </Button>
            ),
          Edit: (props) => <EditIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}}/>,
          Delete: (props) => <DeleteIcon sx={{ color: props?.disabled ? "#bdbdbd" : "#637381"}} />,
        }}
        editable={{
          isDeletable: (rowData) => !rowData.is_default,
          isEditable: (rowData) => !rowData.is_default,
          onRowAdd: (newRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.region?.trim()) {
                  return reject();
                }
              dispatch(
                AddVisitorManagementRegionAction({
                  ...newRow,
                })
              );
              setTimeout(() => resolve(), 500);
            }),
          onRowUpdate: (newRow, oldRow) =>
            new Promise((resolve, reject) => {
              if (!newRow?.region?.trim()) {
                  return reject();
                }
              dispatch(UpdateVisitorManagementRegionAction({
                ...newRow,
              }));
              setTimeout(() => resolve(), 500);
            }),
          onRowDelete: (selectedRow) =>
            new Promise((resolve, reject) => {
              dispatch(
                DeleteVisitorManagementRegionAction({
                  ...selectedRow,
                })
              );
              setTimeout(() => resolve(), 1000);
            }),
        }}
        options={{
          maxBodyHeight: "250px",
          minBodyHeight: "250px",
          rowStyle: { fontSize: "13px" },
          headerStyle: { padding: "5px 10px 5px 25px", fontWeight: "bold" },
          sorting: false,
          search: false,
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: false,
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          addRowPosition: "first",
        }}
        components={{
              Action: (props) => {
                const ActionComponent = props?.components?.Action || MTableAction;
                if (props?.action?.icon && typeof props?.action?.icon === "function") {
                  return (
                    <Box
                      sx={{
                        "& .MuiIconButton-root": {
                          "&:hover": {
                            backgroundColor: "transparent",
                          },
                        },
                      }}
                    >
                      <ActionComponent {...props} />
                    </Box>
                  );
                              
                }
                return <ActionComponent {...props} />;
              },
            }}
        title=""
      />
    </Box>
  );
};
export default VisitorsRegionGrid;
